import { Action } from '../action/action.class'

/**
 * @file Defines the {@link Spin} class.
 * @author <joe.thompson@1x2network.com>
 */

 /**
  * Class for maintaining state of whether game is spinning.
  */
  export class SpinState {

    /**
     * Callback function for on spin
     * @memberof SpinState
     * @public
     * @instance
     * @type {Action}
     */
    onSpin
    
    /**
     * Flag for whether game is spinning
     * @memberof SpinState
     * @protected
     * @instance
     * @type {boolean}
     */
    _spinning

    /**
     * Initialises spinning flag
     */
    constructor() {

        this.onSpin   = new Action()
        this.spinning = false

    }

    /** Get spinning */ get spinning()   { return this._spinning }
    /** Set spinning */ set spinning(v_) { this._spinning = v_ }

  }